import { V2Empty } from '../V2Empty.jsx';
import { Citation } from '../Citation.jsx';

export function V2Sources({ citations }) {
  if (!citations.length) return <V2Empty message="No sources cited in this conversation." />;
  const byKind = { memory: [], episode: [] };
  for (const c of citations) {
    (byKind[c.kind] = byKind[c.kind] || []).push(c);
  }
  return (
    <div className="v2-sources" data-testid="v2-sources">
      {Object.entries(byKind).filter(([, items]) => items.length > 0).map(([kind, items]) => (
        <div key={kind} className="v2-source-group">
          <div className="v2-source-kind-head">{kind}</div>
          {items.map(item => (
            <div key={item.urn} className="v2-source-row">
              <Citation urn={item.urn} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
